import axios from 'axios'

/**
*	Add email to mailchimp
*/
const addEmailToMailchimp = emailAddress => {
	return new Promise((resolve, reject) => {
		axios.post('/.netlify/functions/add-email-to-mailchimp', {
			params: {
				emailAddress: emailAddress
			}
		})
		.then(res => {
			resolve(res)
		})
		.catch(error => {
			reject(error.response.data.error)
		})
	})
}

export { addEmailToMailchimp }